import React, { useMemo, useState } from "react";
import { List, Link, Button } from "@bookingcom/bui-react";
import { useI18n, t, Trans } from "@bookingcom/lingojs-react";
import useModalDialog from "../../../hooks/useModalDialog.js";
import Frame from "../Frame/index.js";
import styles from "./SearchBaggagePolicies.module.css";
import useProfiler from "../../../hooks/useProfiler.js";
import useGetSearchResultsBound from "../../../hooks/useGetSearchResultsBound.js";
import { useSelector } from "react-redux";
import { getSearchResultsBaggagePolicies } from "../../../store/searchResults/selectors.js";
import { getSearchResultsBaggagePolicies as getOBSearchResultsBaggagePolicies } from "../../../store/searchResultsBounds/outboundSelectors.js";
import { getSearchResultsBaggagePolicies as getIBSearchResultsBaggagePolicies } from "../../../store/searchResultsBounds/inboundSelectors.js";
const SearchBaggagePolicies = ({ hideBaggagePolicies }) => {
    const [active, setActive] = useState(false);
    const i18n = useI18n();
    const { isAmerican } = useProfiler();
    const Modal = useModalDialog();
    const bound = useGetSearchResultsBound();
    const bPolicies = useSelector(getSearchResultsBaggagePolicies);
    const bPoliciesOutbound = useSelector(getOBSearchResultsBaggagePolicies);
    const bPoliciesInbound = useSelector(getIBSearchResultsBaggagePolicies);
    const baggagePolicies = useMemo(() => {
        if (hideBaggagePolicies) {
            return undefined;
        }
        if (bound === "outbound") {
            return bPoliciesOutbound;
        }
        if (bound === "inbound") {
            return bPoliciesInbound;
        }
        return bPolicies;
    }, [bPolicies, bPoliciesInbound, bPoliciesOutbound, bound, hideBaggagePolicies]);
    if (!baggagePolicies && !isAmerican()) {
        return null;
    }
    const baggageList = baggagePolicies?.map((policy) => (React.createElement(Link, { href: policy.url, key: policy.code, text: policy.name, attributes: { target: "_blank", "data-testid": "search_baggage_policies_modal_link" } })));
    return (React.createElement(React.Fragment, null,
        React.createElement(Frame, { mb: 4, className: styles.baggagePolicies, attributes: { "data-testid": "search_baggage_policies" } }, baggagePolicies && (React.createElement(Trans, { tag: "flights_sr_baggage_fee_discalimer", variables: {
                start_link: "<0>",
                end_link: "</0>"
            }, components: [
                React.createElement(Button, { variant: "tertiary", onClick: (e) => {
                        e.preventDefault();
                        setActive(true);
                    }, className: styles.modalOpener, key: 0 })
            ] }))),
        React.createElement(Modal, { title: i18n.trans(t("flights_sr_baggage_modal_header")), subtitle: i18n.trans(t("flights_sr_baggage_modal_text")), active: active, onCloseTrigger: () => setActive(false), position: "center", showModalInMobile: true, dataTestId: "search_baggage_policies_modal" },
            React.createElement(List, { divided: true }, baggageList))));
};
export default SearchBaggagePolicies;
